module.exports = __webpack_public_path__ + "img/banner1800.c23d1e12.png";